import { Link } from "@/lib/router-compat";
import { useQuery } from "@tanstack/react-query";
import { PageShell } from "@/components/layout/PageShell";
import { PageHeader } from "@/components/ui/page-header";
import { Seo } from "@/components/seo/Seo";
import { usePublishedTopicPages } from "@/services/topicPagesService";
import { getTopicTagCounts } from "@/services/unifiedNewsService";
import { useT } from "@/i18n/useLocale";
import T from "@/i18n/T";

const Topics = () => {
  const t = useT();
  const { data: pages = [], isLoading } = usePublishedTopicPages();
  const { data: counts = {} } = useQuery({
    queryKey: ["topic-tag-counts"],
    staleTime: 10 * 60 * 1000,
    queryFn: getTopicTagCounts,
  });

  return (
    <PageShell>
      <Seo
        title={t("auto.topics-byteline-d09e")}
        description={t("auto.guides-and-the-latest-coverage-across-ai-dec6")}
        path="/topics"
      />
      <PageHeader
        eyebrow={t("auto.topics-34ac")}
        title={t("auto.topics-34ac")}
        description={t("auto.plain-english-guides-to-the-technologies-a483")}
      />

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-32 rounded-lg bg-muted animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pages.map((topic) => {
            const count = counts[topic.tag];
            const firstParagraph = topic.explainer.split("\n\n")[0] || "";
            return (
              <Link
                key={topic.slug}
                to={`/topics/${topic.slug}`}
                className="group bg-card hover:bg-card/90 border border-border/50 rounded-lg p-5 flex flex-col transition-colors"
              >
                <div className="flex items-baseline justify-between mb-2">
                  <h2 className="text-lg font-semibold group-hover:underline">
                    {topic.title}
                  </h2>
                  {typeof count === "number" && count > 0 && (
                    <span className="text-xs text-muted-foreground shrink-0 ml-3">
                      {count.toLocaleString()} stories
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground line-clamp-3">
                  {firstParagraph}
                </p>
                <span className="mt-auto pt-4 text-sm text-primary font-medium">
                  <T k="auto.read-the-guide-ef42" />
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </PageShell>
  );
};

export default Topics;
